import React, { useState, useEffect } from 'react';

const ExaminationFeaturesRoadmap = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const features = [
    { id: 1, title: "Police Verification, whenever required of Probable Exam Executives", color: "#28A745" },
    { id: 2, title: "Gather Local & external feedback of Centre reputation", color: "#28A745" },
    { id: 3, title: "Alert to City SP/ Commissioner regarding Date of Exam", color: "#EF476F" },
    { id: 4, title: "Coordination with State Police to deploy security through Local PS", color: "#EF476F" },
    { id: 5, title: "TPA for Security Agency besides Centre Security", color: "#EF476F" },
    { id: 6, title: "Availability across State/City (Male/Female) Security Guard", color: "#EF476F" },
    { id: 7, title: "Mandatory Metal Detection/ Frisking, Body and 3 Layer Frisking", color: "#EF476F" }
  ];

  const positions = [8, 22, 36, 50, 64, 78, 92];

  return (
    <div style={{
      // backgroundColor: '#F7F8FA',
      minHeight: '100vh',
      padding: '3rem 1rem',
      fontFamily: "'Segoe UI', Arial, sans-serif"
    }}>
      <div style={{ maxWidth: '100%', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <h3 style={{
            fontWeight: '800',
            color: '#333',
            marginBottom: '50px',
            marginTop : "50px",
            lineHeight: '1.2'
          }}
          className='text-danger title split-collab'
          >
            OTHER FEATURES FOR EXAMINATION MANAGEMENT
          </h3>
          <div style={{
            height: '3px',
            backgroundColor: '#333',
            width: '100%',
            borderRadius: '2px'
          }} />
        </div>

        {/* Desktop Roadmap */}
        {!isMobile && (
          <div style={{ 
            position: 'relative', 
            height: '700px', 
            marginTop: '4rem',
            marginBottom : '1rem'
            // overflow: 'hidden'
          }}>
            {/* Main Road Background */}
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '2%',
              transform: 'translateY(-50%)',
              width: '96%',
              height: '100px',
              background: 'linear-gradient(180deg, #4a4a4a 0%, #2a2a2a 100%)',
              borderRadius: '50px',
              zIndex: 1,
              boxShadow: '0 8px 25px rgba(0,0,0,0.3)'
            }} />
            
            {/* Road Center Line */}
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '2%',
              transform: 'translateY(-50%)',
              width: '96%',
              height: '4px',
              background: 'repeating-linear-gradient(90deg, #FFD700 0px, #FFD700 40px, transparent 40px, transparent 80px)',
              zIndex: 2
            }} />
            
            {/* Road Side Lines */}
            <div style={{
              position: 'absolute',
              top: 'calc(50% - 40px)',
              left: '2%',
              width: '96%',
              height: '2px',
              backgroundColor: 'white',
              zIndex: 2
            }} />
            <div style={{
              position: 'absolute',
              top: 'calc(50% + 40px)',
              left: '2%',
              width: '96%',
              height: '2px',
              backgroundColor: 'white',
              zIndex: 2
            }} />

            {/* Features */}
            {features.map((feature, index) => {
              const isTop = index % 2 === 0;
              const leftPosition = `${positions[index]}%`;

              return (
                <div key={feature.id}>
                  {/* Connection line from road to card */}
                  <div style={{
                    position: 'absolute',
                    left: leftPosition,
                    top: '50%',
                    transform: 'translateX(-50%)',
                    width: '4px',
                    height: '140px',
                    backgroundColor: feature.color,
                    marginTop: isTop ? '-190px' : '50px',  
                    zIndex: 2,
                    borderRadius: '2px'
                  }} />

                  {/* Number circle on road */}
                  <div style={{
                    position: 'absolute',
                    left: leftPosition,
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '60px',
                    height: '60px',
                    backgroundColor: feature.color,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '5px solid white',
                    boxShadow: '0 6px 20px rgba(0,0,0,0.4)',
                    zIndex: 3,
                    fontSize: '20px',
                    fontWeight: 'bold',
                    color: 'white'
                  }}>
                    {feature.id}
                  </div>

                  {/* Feature card */}
                  <div style={{
                    position: 'absolute',
                    left: leftPosition,
                    top: isTop ? '5%' : '75%',
                    transform: 'translateX(-50%)',
                    width: '190px',
                    backgroundColor: feature.color,
                    borderRadius: '15px',
                    padding: '2.8rem',
                    color: 'white',
                    textAlign: 'center',
                    zIndex: 2,
                    transition: 'all 0.3s ease',
                    boxShadow: '0 8px 25px rgba(0,0,0,0.3)',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateX(-50%) scale(1.05) translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateX(-50%) scale(1) translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.3)';
                  }}
                  >
                    <div style={{
                      fontSize: '15px',
                      fontWeight: '600',
                      lineHeight: '1.4'
                    }}>
                      {feature.title}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Mobile Layout */}
        {isMobile && (
          <div>
            {features.map((feature) => (
              <div key={feature.id} style={{ marginBottom: '1.5rem' }}>
                <div style={{
                  backgroundColor: 'white',
                  borderRadius: '15px',
                  padding: '1.5rem',
                  boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
                  borderLeft: `6px solid ${feature.color}`,
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.1)';
                }}
                >
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
                    <div style={{
                      width: '50px',
                      height: '50px',
                      backgroundColor: feature.color,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '18px',
                      flexShrink: 0,
                      boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                    }}>
                      {feature.id}
                    </div>
                    <div style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#333',
                      lineHeight: '1.5'
                    }}>
                      {feature.title}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ExaminationFeaturesRoadmap;